import type { RecommendedContentType } from '../../../models'
import { AdviceCard } from './AdviceCard'

type RecommendationCardProps = {
  content: RecommendedContentType
  whichId: string
  modelId: string
  index: number
  large: boolean
}

export const RecommendationCard = ({
  content,
  whichId,
  modelId,
  index,
  large,
}: RecommendationCardProps) => {
  if (content.__typename === 'RecommendedArticle') {
    return (
      <AdviceCard
        title={content.title}
        subheading={content.subheading}
        primaryLink={content.href}
        imgObj={{
          imageAlt: content.title,
          str: content.image,
        }}
        ariaLabel={`${content.title} advice card`}
        large={large}
        trackingData={{
          'data-which-id': whichId,
          'data-section': 'Recommended for you',
          'data-card-name': content.title,
          'data-index': (index + 1).toString(),
          'data-content-id': content.id,
          'data-model-id': modelId,
        }}
      />
    )
  }

  return null
}
